import { useState } from 'react';
import { ChevronDown, User, Building2 } from 'lucide-react';
import { useFetch } from '../../hooks/useFetch';
import { faqApi } from '../../api/contentApi';
import { PageHero } from '../../components/ui/PageHero';
import { Reveal } from '../../components/ui/Reveal';
import { SkeletonText } from '../../components/ui/Skeleton';
import '../../components/ui/CategoryFilter.css';
import { Seo } from '../../components/ui/Seo';
import './Faq.css';

const FILTRES = [
  { id: '', label: 'Toutes les questions' },
  { id: 'particulier', label: 'Particuliers' },
  { id: 'professionnel', label: 'Professionnels' },
];

const UNIVERS_BADGE = {
  particulier: { label: 'Particulier', icon: User, tone: 'primary' },
  professionnel: { label: 'Professionnel', icon: Building2, tone: 'secondary' },
};

export function Faq() {
  const { data: faqs, loading } = useFetch(() => faqApi.list(), []);
  const [filtre, setFiltre] = useState('');
  const [ouvertId, setOuvertId] = useState(null);

  const faqsFiltrees = filtre ? faqs?.filter((f) => f.univers === filtre || f.univers === 'commun') : faqs;

  return (
    <>
      <Seo
        title="Questions fréquentes — AXEO Services Cergy"
        description="Toutes les réponses à vos questions sur nos services à la personne et nos solutions professionnelles à Cergy-Pontoise : tarifs, crédit d'impôt, intervention, zones desservies."
        path="/particuliers/faq"
      />

      <PageHero
        eyebrow="Aide"
        title="Questions fréquentes"
        subtitle="Tout ce qu'il faut savoir avant de se lancer, pour les particuliers comme pour les professionnels."
      />

      <section className="section">
        <div className="container faq-page">
          <div className="faq-filters" role="group" aria-label="Filtrer les questions">
            {FILTRES.map((f) => (
              <button
                key={f.id}
                type="button"
                className={`filter-chip ${filtre === f.id ? 'filter-chip--active' : ''}`}
                onClick={() => setFiltre(f.id)}
              >
                {f.label}
              </button>
            ))}
          </div>

          <div className="faq-list">
            {loading && <SkeletonText lines={5} />}
            {!loading && !faqsFiltrees?.length && <p>Aucune question pour le moment.</p>}

            {faqsFiltrees?.map((faq, i) => {
              const badge = UNIVERS_BADGE[faq.univers];
              const estOuvert = ouvertId === faq.id;

              return (
                <Reveal as="div" key={faq.id} delay={Math.min(i * 40, 240)}>
                  <div className={`faq-item ${estOuvert ? 'faq-item--open' : ''}`}>
                    <button
                      type="button"
                      className="faq-item__trigger"
                      onClick={() => setOuvertId(estOuvert ? null : faq.id)}
                      aria-expanded={estOuvert}
                    >
                      <span className="faq-item__question">
                        {badge && (
                          <span className={`faq-item__badge faq-item__badge--${badge.tone}`}>
                            <badge.icon size={12} /> {badge.label}
                          </span>
                        )}
                        {faq.question}
                      </span>
                      <ChevronDown size={18} className="faq-item__chevron" />
                    </button>
                    <div className="faq-item__panel">
                      <div className="faq-item__panel-inner">
                        <p>{faq.reponse}</p>
                      </div>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
